import MPACustomers from './MPACustomers';

export default MPACustomers;
